<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <trash-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Delete Business Plan</h3>
          <div class="tw-mt-2">
            <p class="tw-font-thin tw-text-gray-600">Are you sure you want to delete {{ name }}?</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="del" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Confirm</base-button>
        <base-button @click="close" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-business-plan-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import { TrashIcon } from "@/assets/svgs";

export default {
  name: "BusinessPlanDeleteConfirmationModal",
  components: { InlineError, TrashIcon },
  data() {
    return {
      businessId: null,
      businessPlanId: null,
      name: null,
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    reset() {
      this.businessId = null;
      this.businessPlanId = null;
      this.name = null;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    show(businessId, businessPlanId, name) {
      this.reset();

      this.businessId = businessId;
      this.businessPlanId = businessPlanId;
      this.name = name;

      this.$refs.modal.show();
    },
    close() {
      this.$refs.modal.hide();
    },
    del() {
      this.isLoading = true;
      this.$axios
        .delete(`/businesses/${this.businessId}/plans/${this.businessPlanId}`)
        .then(() => {
          this.isLoading = false;
          this.close();
          this.$emit("delete");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Plan Deleted", message: "The plan was deleted successfully" });
        })
        .catch((err) => {
          this.isLoading = false;
          this.errorTitle = `Failed to delete the Business Plan`;
          this.errorMessage = `BusinessPlanId ${this.businessPlanId} was not able to be deleted. Please try again.`;
          this.error = err;
        });
    },
  },
};
</script>
